import React from 'react';
import Page from './page';

export default function LoadPage(props) {
    return (
        <Page />
    );
}